let storeContent = generateStore({
   loading: false,
   show: false,
   show_edit_modal: false,
   show_create_modal: false,
   show_delete_modal: false,
   delete_message: '',
   user_role: null,
   router: null
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      mainLogInAction(ctx,{res,payload}) {
         try {
            payload.router.push({ name: process.env.VUE_APP_AUTH_SUCCESS_COMPONENT || 'Typography'})
         } catch (error) {
         }
      }
   }
};

function generateStore(data) {
   let state = {}, getters = {}, mutations = {}

   for (const [key, obj] of Object.entries(data)) {
      state[key] = obj
      getters[key] = state => { return state[key] }
      mutations[key] = (state, content) => { state[key] = content }
   }

   return { state, getters, mutations }
}